"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardSalesOrderCustomer = void 0;
class ProductDashboardSalesOrderCustomer {
}
exports.ProductDashboardSalesOrderCustomer = ProductDashboardSalesOrderCustomer;
//# sourceMappingURL=product-dashboard-sales-order-customer.response.js.map